import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars } from "@fortawesome/free-solid-svg-icons"

interface HeaderProps {
  siteTitle: string
}

const Header = ({ siteTitle }: HeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <header className="shubhi-header">
      <nav className="navbar-nav">
        <div className="nav-horizontal">
          <Link to="/">
          <StaticImage
            src="../images/logo-black.webp"
            placeholder="none"
            height={45}
            alt="Shubhi Shrivastava"
          />
        </Link>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/projects">Projects</Link>
          </li>
          <li>
            <Link to="/photography-and-film">Photography & Film</Link>
          </li>
          <li>
            <Link to="/artwork">Artwork</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
        </div>
        <div className="nav-actions">
          <Link to="/">
            <StaticImage
              src="../images/logo-black.webp"
              placeholder="none"
              height={45}
              alt="Shubhi Shrivastava"
            />
          </Link>
          <a onClick={() => toggleMenu()} className="iconButton">
            <FontAwesomeIcon icon={faBars} />
          </a>
        </div>
        {isMenuOpen && (
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/projects">Projects</Link>
            </li>
            <li>
              <Link to="/photography-and-film">Photography & Film</Link>
            </li>
            <li>
              <Link to="/artwork">Artwork</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        )}
      </nav>
    </header>
  )
}

export default Header
